import { isEmpty } from 'radash';
import { stripTrailingSlash } from 'utils/url';

export const ACCESS_DENIED_PATH = '/access-denied';

type TenantAccessClaims = {
  iss?: string;
  tenant_ids?: string[];
};

export const getDeploymentTenantId = (): string => process.env.TENANT_ID ?? '';

export const isKeycloakIssuer = (iss?: string): boolean => {
  const expected = process.env.KEYCLOAK_ISSUER ?? '';

  if (!iss || !expected) {
    return false;
  }

  return stripTrailingSlash(iss) === stripTrailingSlash(expected);
};

export const parseTenantIds = (claim?: unknown): string[] => {
  if (!Array.isArray(claim)) {
    return [];
  }

  return claim.filter((id): id is string => typeof id === 'string' && id.length > 0);
};

export const hasAccessToThisDeployment = (decoded: TenantAccessClaims): boolean => {
  const tenantId = getDeploymentTenantId();

  if (!tenantId) {
    return true;
  }

  if (isEmpty(decoded.tenant_ids)) {
    return !isKeycloakIssuer(decoded.iss);
  }

  return parseTenantIds(decoded.tenant_ids).includes(tenantId);
};
